import { Inject, inject, Injectable, NgZone } from '@angular/core';
import { ApiUrls } from '../backoffice-urls';
import { EnvConfig, Environment } from '@doc/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DrawingRepositoryService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  tabChangeDateTransfer = new BehaviorSubject<any>(null);

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  sendTabChangeDate(data: any) {
    this.tabChangeDateTransfer.next(data);
  }
  reaciveTabChangeDate(): Observable<any> {
    return this.tabChangeDateTransfer.asObservable();
  }

  getCommentByFileId(id: any, val: any) {
    return this.http.post(this.apiUrl + ApiUrls.Comments.GET + id, val);
  }

  createComment(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.Comments.CREATE, val);
  }

  editComment(id: any, val: any) {
    return this.http.post(this.apiUrl + ApiUrls.Comments.UPDATE + id, val);
  }

  deleteComment(id: any) {
    return this.http.get(this.apiUrl + ApiUrls.Comments.DELETE + id);
  }

  chatSendQuestion(val: any) {
    let headers = new HttpHeaders({ "X-Skip-Loader": "true" })
    return this.http.post(this.apiUrl + ApiUrls.Chat.SEND_QUESTION, val, { headers });
  }

  FileAiReport(id: any) {
    return this.http.get(this.apiUrl + ApiUrls.ArchitecturalDeatil.GET + id);
  }

  getAnalyzedQuestionnaireByFileId(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.ArchitecturalDeatil.getAnalyzedQuestionnaireByFileId, val);
  }
  getAnalyzedQAByFileId(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.ArchitecturalDeatil.getAnalyzedQAByFileId, val);
  }

  getNonApprovedAnalysisReport(fileId: any) {
    return this.http.get(this.apiUrl + ApiUrls.ArchitecturalDeatil.getNonApprovedAnalysisReport + fileId,{ responseType: 'text' });
  }

  TriggerAIAnalysis(id: any) {
    return this.http.get(this.apiUrl + ApiUrls.TriggerAIAnalysis + id);
  }



  // ws://kd-api.fit-infotech.com/ws/chat?file_id=26&question=

  private url = `${this.config.apiUrl}/ws/chat`
  private ws?: WebSocket;
  private messageSubject = new Subject<string>();
  private completeSubject = new Subject<void>();
  private zone = inject(NgZone);

  connect(fileId: number, question: string): void {
    const url = `${this.url}?file_id=${fileId}&question=${encodeURIComponent(question)}`;
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      console.log('✅ Connected to', url);
    };

    this.ws.onmessage = (event) => {
      this.zone.run(() => {
        try {
          const data = JSON.parse(event.data);

          if (data.chunk) {
            this.messageSubject.next(data.chunk);
          }

          if (data.complete) {
            this.completeSubject.next();
            this.disconnect();
          }
        } catch (e) {
          console.error('Invalid message format:', event.data);
          this.disconnect();
        }
      });
    };

    this.ws.onclose = () => {
      console.log('❌ Disconnected from WebSocket');
      this.disconnect();
    };
  }

  // Observable for message stream
  onMessage(): Observable<string> {
    return this.messageSubject.asObservable();
  }

  // Observable for completion event
  onComplete(): Observable<void> {
    return this.completeSubject.asObservable();
  }

  disconnect(): void {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.close();
    }
    this.ws = undefined;
  }

}
